export const HOST = 'https://us-central1-carbografitos.cloudfunctions.net/api/'; 
//export const HOST = 'http://localhost:5000/carbografitos/us-central1/api/';